export const storageKeys = {
  PANEL_CODE: 'sgp:panelCode',
  GROUP_NAME: 'sgp:groupName',
  DEVICE_CODE: 'sgp:deviceCode',
  ACCESS_TOKEN: 'sgp:accessToken',
  REFRESH_TOKEN: 'sgp:refreshToken',
  SELECTED_PRODUCT: 'sgp:selectedProduct',
  REDIRECT_AFTER_AUTH: 'redirectToAfterLogin',
  IP_ADDRESS: 'ip',
};
